import { useMemo } from 'react';
import { FindMyProjectWithControls } from '@ansvar-sakerhet/api-client';

export const useContractors = (
  project: FindMyProjectWithControls | undefined
) => {
  const subcontractors = useMemo(() => {
    const controls = project?.controls ?? [];

    const nonUniqueSubcontractors = controls.flatMap(
      ({ companies }) => companies
    );
    nonUniqueSubcontractors.push(...(project?.Company ?? []));

    return nonUniqueSubcontractors.filter(
      ({ registrationNumber: regNrToFind }, index, arr) => {
        const foundIndex = arr.findIndex(
          ({ registrationNumber }) => registrationNumber === regNrToFind
        );

        return foundIndex === index;
      }
    );
  }, [project]);

  return { subcontractors };
};
